import React from 'react';
import ManufacturingScheduleContainer from '../../containers/schedulemng/ManufacturingScheduleContainer';

const ManufacturingSchedulePage = () => {
  return <ManufacturingScheduleContainer />;
};

export default ManufacturingSchedulePage;
